"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.unformat = exports.numberFormatter = exports.stripTrailingZeros = void 0;
const tslib_1 = require("tslib");
const prefStorage = tslib_1.__importStar(require("./pref-storage"));
const factors = {
    gb: 1e-9,
    mb: 1e-6,
    mbps: 8 / 1e6,
    ms: 1e-3,
    s: 1e-6
};
function stripTrailingZeros(number) {
    return number.replace(/\.?0+$/, '');
}
exports.stripTrailingZeros = stripTrailingZeros;
function numberFormatter(number, unit, scaleTo = number) {
    const factor = factors[unit] || 1;
    number = (typeof number === 'number' ? number : parseFloat(number)) * factor;
    scaleTo =
        (typeof scaleTo === 'number' ? scaleTo : parseFloat(scaleTo)) * factor;
    if (number > scaleTo) {
        scaleTo = number;
    }
    const isNegative = number < 0;
    // This is for tiny percentages
    if (scaleTo !== 0 && !isNegative && scaleTo <= 0.1) {
        return stripTrailingZeros(number.toPrecision(3));
    }
    const activeView = prefStorage.get('active-view');
    if (activeView && activeView.type === 'apollo') {
        return number.toFixed(2);
    }
    if (scaleTo >= 1e3) {
        return number.toFixed(0);
    }
    if (scaleTo >= 1) {
        return number.toPrecision(3);
    }
    return number.toPrecision(2);
}
exports.numberFormatter = numberFormatter;
function unformat(number, unit) {
    return parseFloat(number) / (factors[unit] || 1);
}
exports.unformat = unformat;
//# sourceMappingURL=number-formatter.js.map